export const checkBounds = (index, array) => {
    if (index >= array.length || index < 0)
        throw new Error(`Index must be between greater then  or equal to 0 and lower then ${array.length} but is ${index}.`);
};
export const findFirst = (i, data) => {
    let index = undefined;
    try {
        while (index === undefined) {
            if (data(i) != null) {
                index = i;
            }
            else {
                i++;
            }
        }
    }
    catch (error) {
        //i === after last data index
    }
    return index;
};
export const findAfter = (milli, time, data, from) => {
    let index = undefined;
    let i = from;
    try {
        while (index === undefined) {
            if (time(i) >= milli && data(i) != null) {
                index = i;
            }
            else {
                i++;
            }
        }
    }
    catch (error) {
        //i === after last data index
    }
    return index;
};
export const findBefore = (milli, time, data, from) => {
    let index = undefined;
    let i = from;
    while (i >= 0 && index === undefined) {
        if (time(i) < milli && data(i) != null) {
            index = i;
        }
        else {
            i--;
        }
    }
    return index;
};
export const getDomain = (data) => {
    let vMin = undefined;
    let vMax = undefined;
    let i = 0;
    let value;
    try {
        while (true) {
            value = data(i++);
            if (value != null) {
                vMin = vMin !== undefined ? Math.min(vMin, value) : value;
                vMax = vMax !== undefined ? Math.max(vMax, value) : value;
            }
        }
    }
    catch (error) {
        //i === after last data index
    }
    return [vMin, vMax];
};
